export enum NotificationTypeEnum { 
  Unread, Problem, Announcement, Warning, Information, Read
}

export enum ProfileTabs {
  Profile, Availabilities, Absences, Calendar, MeetingType, Security
}